<!-- =========================================================================================
  File Name: NursingHomes.vue
  Description: Nursing Home List
========================================================================================== -->
<template>
	<div id="NursingHomes">
    <vs-row class="top-row">
      <vs-col vs-type="flex" vs-w="12">
        <vs-button @click="viewAddNHDialog()" class="add-btn-top" color="primary" type="gradient" icon="library_add">Add Nursing Home</vs-button>
      </vs-col>
    </vs-row>
		<vs-row vs-justify="left">
      <vs-col :data="nHomes" :key="indextr" v-for="(nHomes, indextr) in nursingHomes" type="flex" vs-justify="center" vs-align="left" vs-w="3.8" class="cardx-holder">
          <vx-card
          class="main-nh-con"
          title-color="#fff"
          :card-background="'linear-gradient(120deg ,rgba(160, 97, 106, 0.5), rgba(160, 97, 106, 0.3)), url(' + nHomes.nursingHomeLogo + ')'"
          content-color="#fff">
              <div class="my-6">
                  <h5 class="mb-2 text-white">{{ nHomes.name }}</h5>
                  <p class="text-white">{{ nHomes.address }}</p>
                  <p class="text-white">{{ nHomes.city }}</p>
                  <p class="text-white">{{ nHomes.state }} - {{ nHomes.zipcode }}</p>
              </div>
              <vs-divider></vs-divider>
              <div class="flex justify-between flex-wrap">
                <vx-tooltip delay=".5s" text="View Staff">
                  <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" :to="{ name: 'nursing-home-staff', params: { nhID: nHomes.id } }"><vs-icon icon="pageview" size="25px" color="white"></vs-icon></vs-button>
                </vx-tooltip>
                <vx-tooltip delay=".5s" text="Edit Details">
                  <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" @click="viewNHDetails(nHomes)"><vs-icon icon="edit" size="25px" color="white"></vs-icon></vs-button>
                </vx-tooltip>
                <vx-tooltip delay=".5s" text="Delete">
                  <vs-button class="mr-1.5 shadow-lg" type="gradient" color="rgba(160, 97, 106, 0.8)" gradient-color-secondary="rgba(160, 97, 106, 0.8)" @click="confirmDeletion(nHomes.id)"><vs-icon icon="delete_outline" size="25px" color="#fff"></vs-icon></vs-button>
                </vx-tooltip>
              </div>
          </vx-card>          
     </vs-col>
      <!-- Dialog box for view nusrsing home details  -->
      <vs-prompt
        color="danger"
        class="centerx nh-edit-detail-popup"
        title="Nursing Home Details"
        acceptText="Save"
        @accept="updateNursingHome"
         :active.sync="activeDetailView">
         <div class="con-exemple-prompt vx-row">
           <div class="section-upload vx-col w-1/2">
            <vs-upload limit="1" ref="NHLogo" accept="image/jpeg, image/png, image/jpg" text="Upload logo" @change="logoChange" /> 
            <!-- <input type="file" ref="NHLogo" :name="updateNHLogo"  @change="logoChange" accept="image/jpeg, image/png, image/jpg" class="input-file"> -->
           </div>
           
           <div class="section-img-show vx-col w-1/2">
              <div class="nh-inner-img">
                <img :src="nh_ext_logo" class="nh-ext-logo">
              </div>
            </div>
            
            <div class="vx-col w-full">
              <vs-input v-validate="'required|alpha_spaces'" placeholder="Name" name="name" v-model="name"/>
              <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
            </div>
            
            <div class="vx-col w-full">
            <vs-input v-validate="'required'" placeholder="Address" name="address" v-model="address"/>
            <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
            </div>
    
            <div class="vx-col w-1/2 custom-mrg-fix">
            <vs-input v-validate="'required|alpha_spaces'" placeholder="City" name="city" v-model="city"/>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{ errors.first('city') }}</span>
            </div>
            <div class="vx-col w-1/2 custom-mrg-fix">
              <vs-input v-validate="'required|alpha_spaces'" placeholder="State" name="state" v-model="state"/>
              <span class="text-danger text-sm" v-show="errors.has('state')">{{ errors.first('state') }}</span>
            </div>

            <div class="vx-col w-1/2 custom-mrg-fix">
              <vs-input v-validate="'required|numeric|min:5|max:5'" name="zipcode" placeholder="Zipcode" v-model="zipcode"/>
              <span class="text-danger text-sm" v-show="errors.has('zipcode')">{{ errors.first('zipcode') }}</span>
            </div>
            <div class="vx-col w-1/2 custom-mrg-fix">
              <vs-input v-validate="'required|between:0,100'" name="couponLimit" placeholder="Coupon Limit" v-model="couponLimit"/>
              <span class="text-danger text-sm" v-show="errors.has('couponLimit')">{{ errors.first('couponLimit') }}</span>
            </div>
         </div>
       </vs-prompt>

      <!-- dialog box for adding new nusrsing home  -->
      <vs-prompt
        color="success"
        class="centerx nh-add-nursing-home"
        title="Add Nursing Home"
        acceptText="Add"
        @accept="addNursingHome"
         :active.sync="activeAddView">
         <div class="con-exemple-prompt vx-row">
           <div class="section-upload w-full centerx">
            <vs-upload limit="1" ref="AddNHLogo" accept="image/jpeg, image/png, image/jpg" text="Upload logo" @change="addLogoChange" /> 
            <!-- <input type="file" ref="NHLogo" :name="updateNHLogo"  @change="logoChange" accept="image/jpeg, image/png, image/jpg" class="input-file"> -->
           </div>
          
          <div class="vx-col w-full">
            <vs-input v-validate="'required|alpha_spaces'" placeholder="Name" name="nh_name" v-model="nh_name"/>
            <span class="text-danger text-sm" v-show="errors.has('nh_name')">{{ errors.first('nh_name') }}</span>
          </div>
          
          <div class="vx-col w-full">
           <vs-input v-validate="'required'" placeholder="Address" name="nh_address" v-model="nh_address"/>
           <span class="text-danger text-sm" v-show="errors.has('nh_address')">{{ errors.first('nh_address') }}</span>
          </div>
  
          <div class="vx-col w-1/2 custom-mrg-fix">
           <vs-input v-validate="'required|alpha_spaces'" placeholder="City" name="nh_city" v-model="nh_city"/>
           <span class="text-danger text-sm" v-show="errors.has('nh_city')">{{ errors.first('nh_city') }}</span>
          </div>
          <div class="vx-col w-1/2 custom-mrg-fix">
            <vs-input v-validate="'required|alpha_spaces'" placeholder="State" name="nh_state" v-model="nh_state"/>
            <span class="text-danger text-sm" v-show="errors.has('nh_state')">{{ errors.first('nh_state') }}</span>
          </div>

          <div class="vx-col w-1/2 custom-mrg-fix">
            <vs-input v-validate="'required|numeric|min:5|max:5'" name="nh_zipcode" placeholder="Zipcode" v-model="nh_zipcode"/>
            <span class="text-danger text-sm" v-show="errors.has('nh_zipcode')">{{ errors.first('nh_zipcode') }}</span>
          </div>
          <div class="vx-col w-1/2 custom-mrg-fix">
            <vs-input v-validate="'required|between:0,100'" name="nh_couponLimit" placeholder="Coupon Limit" v-model="nh_couponLimit"/>
            <span class="text-danger text-sm" v-show="errors.has('nh_couponLimit')">{{ errors.first('nh_couponLimit') }}</span>
          </div>
         </div>
       </vs-prompt>

    </vs-row>
	</div>
</template>
<script>
// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    nh_name: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    nh_address: {
      required: 'Field is required'
    },
    nh_city: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    nh_state: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    nh_zipcode: {
      required: 'Field is required',
      numeric: 'Invalid value'
    },
    nh_couponLimit: {
      required: 'Field is required',
      between: 'Limit between 0 and 100'
    },

    name: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    address: {
      required: 'Field is required'
    },
    city: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    state: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    zipcode: {
      required: 'Field is required',
      numeric: 'Invalid value'
    },
    couponLimit: {
      required: 'Field is required',
      between: 'Limit between 0 and 100'
    }    
  }
}

// register custom messages
Validator.localize('en', dict)


export default{
  data () {
	  return {
	    publicPath: process.env.BASE_URL,
      nursingHomes: [],
      activeConfirm:false,
      // for update nursing home
      activeDetailView: false,
      nhID: '',
      name: '',
      address: '',
      city: '',
      state: '',
      zipcode: '',
      couponLimit: '',
      updateNHLogo: '',
      errorList: [],
      //for adding new nursing home
      activeAddView: false,
      nh_name: '',
      nh_address: '',
      nh_city: '',
      nh_state: '',
      nh_zipcode: '',
      nh_couponLimit: '',
      nh_AddNHLogo: '',
      nh_ext_logo: ''
	  }
  },
  methods: {
    nursingHomesList () {
      this.$vs.loading()
      this.$http.get('/nursing-home/')
        .then((response) => {
          if (response.data.messageType == 'success') {
            this.nursingHomes = JSON.parse(JSON.stringify(response.data.data))
            this.$vs.loading.close()
            return this.nursingHomes
          } else {
            this.$vs.loading.close()
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.nursingHomes
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.nursingHomes
        })
    },
    confirmDeletion (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure ?',
        text: 'You want to delete this Nursing Home ?',
        accept: this.DeleteNursingHome,
        acceptText: 'Delete',
        parameters: id
      })
      return true
    },
    DeleteNursingHome (id) {
      console.log(id)
      //return false;
      this.$vs.loading()
      const payload = JSON.stringify({ nursingHomeID: id })
      this.$http.delete('/nursing-home/', {data: { nursingHomeID: id }})
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'Nursing Home removed successfully.', color:'success', position:'top-right', icon:'check_box', time:5000})
            return this.nursingHomesList()
          } else {

            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.nursingHomesList()
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.nursingHomesList()
        })
    },
    viewNHDetails (nhInfo) {
      this.nhID = nhInfo.id
      this.name = nhInfo.name
      this.address = nhInfo.address
      this.city = nhInfo.city
      this.state = nhInfo.state
      this.zipcode = nhInfo.zipcode
      this.couponLimit = nhInfo.couponLimit
      console.log(nhInfo.nursingHomeLogo)
      this.$refs.NHLogo = nhInfo.nursingHomeLogo
      this.nh_ext_logo = nhInfo.nursingHomeLogo
      this.activeDetailView = true

    },
    logoChange () {
      this.updateNHLogo = this.$refs.NHLogo.filesx[0]
    },
    updateNursingHome () {
      this.errorList = []

      this.$validator.validateAll().then(result => {
        if (result) {

          // if form have no errors
          this.$vs.loading()
          const formData = new FormData()
          formData.append('nursingHomeID', this.nhID)
          formData.append('name', this.name)
          formData.append('address', this.address)
          formData.append('city', this.city)
          formData.append('state', this.state)
          formData.append('zipcode', this.zipcode)
          formData.append('couponLimit', this.couponLimit)
          formData.append('nursingHomeLogo', this.updateNHLogo)          
          this.$http.put('/nursing-home/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.$vs.notify({title:'Great!', text:'Nursing Home details updated.', color:'success', position:'top-right', icon:'check_box', time:5000})
                return this.nursingHomesList()
              } else {

                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.nursingHomesList()
              }

            })
            .catch((error)   => {
              console.log(error)
              this.$vs.loading.close()
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.nursingHomesList()
            })
        } else {
          // form have errors
          this.activeDetailView = true
          return false
        }
      })      
    },
    viewAddNHDialog () {
      this.activeAddView = true
    },
    addLogoChange () {
      this.nh_AddNHLogo = this.$refs.AddNHLogo.filesx[0]
    },
    addNursingHome () {
      this.errorList = []      
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.nh_AddNHLogo) {
            this.$vs.notify({title:'Attention!', text:'Please add a Nursing Home logo.', color:'warning', position:'top-right', icon:'error', time:5000})
            this.activeAddView = true
            return false
          }
        
          // if form have no errors
          this.$vs.loading()
          const formData = new FormData()
          formData.append('name', this.nh_name)
          formData.append('address', this.nh_address)
          formData.append('city', this.nh_city)
          formData.append('state', this.nh_state)
          formData.append('zipcode', this.nh_zipcode)
          formData.append('couponLimit', this.nh_couponLimit)
          formData.append('nursingHomeLogo', this.nh_AddNHLogo)          
          this.$http.post('/nursing-home/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.$vs.notify({title:'Great!', text:'Nursing Home added.', color:'success', position:'top-right', icon:'check_box', time:5000})
                return location.reload()
                //return this.nursingHomesList()
              } else {

                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.nursingHomesList()
              }

            })
            .catch((error)   => {
              console.log(error)
              this.$vs.loading.close()
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.nursingHomesList()
            })
        } else {
          this.activeAddView = true
          return false
          // form have errors
        }
      })      
    }
  },
  created () {
    this.nursingHomesList()
  }
}
</script>
<style>
.cardx-holder{ margin: 0 15px 20px; }
.cardx-holder .main-nh-con{
    background-repeat: no-repeat !important;
    background-position: center !important;
    background-size: contain !important;
}
.cardx-holder .main-nh-con .my-6{ 
  background: rgba(160, 97, 106, 0.8);
  border-radius: 5px;
  text-align: left;
  padding: 15px 20px;
} 
.cardx-holder img.fixed-height {
    overflow: hidden;
}
.top-row .add-btn-top { padding: 16px 16px !important; margin: 0 0 30px !important;}
.con-exemple-prompt {  padding: 10px; padding-bottom: 0px;}
.vs-input { width: 100%; margin-top: 10px; padding:0 10px; float: left;}

.vx-card .vx-card__collapsible-content img.prompt-ext-logo {
    display: block;
    width: 100%;
    height: 120px;
}
.con-vs-dialog .vs-dialog .vs-dialog-text { padding: 0 10px 15px; float: left;}
.vs-component.vs-con-input-label.vs-input.w-50.vs-input-primary {width: 50%;}
.con-exemple-prompt {float: left; padding: 0 5px;}
.con-exemple-prompt .section-upload .con-input-upload {width: 300px; height: 110px;}
.con-vs-dialog .vs-dialog {max-width: 480px;}
.con-vs-dialog .vs-dialog .vs-dialog-text {
    float: left;
    width: 100%;
}
.con-vs-dialog .vs-dialog footer {
    padding: 1rem;
    float: left;
    width: 100%;
}
</style>
